import React, { useState, useEffect } from "react";
import { Row, Col, Button, Space, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckOutlined, Loading3QuartersOutlined } from "@ant-design/icons";
import { getFormulationPhotogalleryById } from "../photoGallery/PhotoGallerySlice";
import { getclassficationFormulation } from "../plant&lab/Plant&LabSlice";
import { getUtilities } from "../utilities/redux/UtilitiesSlice";
import PlantAndLab from "../plant&lab/Plant&Lab";
import Utilities from "../utilities/Utilities";
import PhotoGallery from "../photoGallery/PhotoGallery";
import ManageAddFormulation from "./addFormulation/ManageAddFormulation";
import ButtonField from "../../../../../common/htmlComponents/ButtonField";
import ConfirmAlertModel from "../api/ConfirmAlertModel";
import ConfirmAlertPrevious from "../cdmo/ConfirmAlertPrevious";
import ConfirmPreviousFacility from "../cdmo/ConfirmPreviousFacility";
import RequiredFieldsNextModel from "../api/addProduct/RequiredFieldsNextModal";
import RequiredFieldsModel from "../api/addProduct/RequiredFieldsModel";
import { useUnsavedChanges } from "../../../../UnsavedChangesProvider";
const Formulation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setUnsavedChanges } = useUnsavedChanges();
  const navigate = useNavigate();
  const { facilityId } = useParams();
  const facility_id = atob(facilityId);

  const formulationCount = useSelector(
    (state) => state.addFormulation.formulationCount
  );
  const plantLabCount = useSelector(
    (state) => state.plantLab.classificationFormulationCount
  );
  const utilityCount = useSelector(
    (state) => state.UtilitiesCount.utilityCount
  );
  const utilitiesSystem = useSelector(
    (state) => state.UtilitiesCount.utilitiesSystem
  );
  const photoGalleryFormulation_count = useSelector(
    (state) => state.photoGallery.photoGalleryFormulation_count
  );

  const formulationMaster = useSelector(
    (state) => state.addFormulation.formulationMaster
  );
  const plantLab_formulation_id = useSelector(
    (state) => state.addFormulation.formulationPlantLabId
  );
  const utility_formulation_id = useSelector(
    (state) => state.addFormulation.formulationUtilityId
  );
  const subutility_formulation_id = useSelector(
    (state) => state.addFormulation.formulationSubUtilityId
  );
  const waterTreatmet_formulation_id = useSelector(
    (state) => state.addFormulation.formulationWaterTreatmetId
  );
  const initialState = {
    currenttab: 0,
    child1: false,
    child2: false,
    child3: false,
    child4: false,
  };
  const [currentTab, setCurrentTab] = useState(initialState);
  const [tabName, setTabName] = useState("showAddFormulationComponent");
  const [showAddFormulationComponent, setShowAddFormulationComponent] =
    useState(true);
  const [showPlantAndLabComponent, setShowPlantAndLabComponent] =
    useState(false);
  const [showUtilitiesComponent, setShowUtilitiesComponent] = useState(false);
  const [showPhotoGalleryComponent, setShowPhotoGalleryComponent] =
    useState(false);
  const [componentArrIndex, setComponentArrIndex] = useState(0);
  const [isModalOpenc, setIsModalOpenc] = useState(false);
  const [isModalOpenc1, setIsModalOpenc1] = useState(false);
  const [isModalOpenc3, setIsModalOpenc3] = useState(false);
  const [isModalOpenc4, setIsModalOpenc4] = useState(false);
  const [
    isModalNextValidationFormulation,
    setIsModalNextValidationFormulation,
  ] = useState(false);
  const [
    isModalOpenValidationFormulation,
    setIsModalOpenValidationFormulation,
  ] = useState(false);

  useEffect(() => {
    if (formulationMaster) {
      dispatch(getFormulationPhotogalleryById(formulationMaster));
    }
    if (plantLab_formulation_id) {
      dispatch(getclassficationFormulation(plantLab_formulation_id));
    }
    if (utility_formulation_id) {
      dispatch(getUtilities(utility_formulation_id));
    }
  }, [
    dispatch,
    formulationMaster,
    plantLab_formulation_id,
    utility_formulation_id,
    utilitiesSystem,
  ]);

  const componentArr = [
    "showAddFormulationComponent",
    "showPlantAndLabComponent",
    "showUtilitiesComponent",
    "showPhotoGalleryComponent",
  ];

  const handleCancelc = () => {
    setIsModalOpenc(false);
  };
  const handleCancelc1 = () => {
    setIsModalOpenc1(false);
  };
  const handleCancelc3 = () => {
    setIsModalOpenc3(false);
  };
  const handleCancelc4 = () => {
    setIsModalOpenc4(false);
  };
  const handleCancelNextValidationFormulation = () => {
    setIsModalNextValidationFormulation(false);
  };
  const handleCancelValidationFormulation = () => {
    setIsModalOpenValidationFormulation(false);
  };

  const hideComponent = (name) => {
    switch (name) {
      case "showAddFormulationComponent":
        setShowAddFormulationComponent(true);
        setShowPlantAndLabComponent(false);
        setShowUtilitiesComponent(false);
        setShowPhotoGalleryComponent(false);
        setComponentArrIndex(0);
        setCurrentTab((prevState) => ({
          ...prevState,
          currenttab: 0,
        }));

        break;
      case "showPlantAndLabComponent":
        setShowPlantAndLabComponent(true);
        setShowAddFormulationComponent(false);
        setShowUtilitiesComponent(false);
        setShowPhotoGalleryComponent(false);
        setComponentArrIndex(1);
        setCurrentTab((prevState) => ({
          ...prevState,
          currenttab: 1,
        }));
        break;
      case "showUtilitiesComponent":
        setShowUtilitiesComponent(true);
        setShowPlantAndLabComponent(false);
        setShowAddFormulationComponent(false);
        setShowPhotoGalleryComponent(false);
        setComponentArrIndex(2);
        setCurrentTab((prevState) => ({
          ...prevState,
          currenttab: 2,
        }));
        break;
      case "showPhotoGalleryComponent":
        setShowPhotoGalleryComponent(true);
        setShowPlantAndLabComponent(false);
        setShowAddFormulationComponent(false);
        setShowUtilitiesComponent(false);
        setComponentArrIndex(3);
        setCurrentTab((prevState) => ({
          ...prevState,
          currenttab: 3,
        }));

        break;
      default:
    }
  };
  const handleNext = () => {
    // let showTabName = componentArr[componentArrIndex + 1];
    // hideComponent(showTabName);
    if (currentTab.child3 === false && currentTab.child4 === false) {
      if (currentTab.child1 === false && currentTab.child2 === false) {
        let showTabName = componentArr[componentArrIndex + 1];
        hideComponent(showTabName);
      } else {
        setIsModalOpenc(true);
        // console.log(currenttab);
      }
    } else {
      setIsModalNextValidationFormulation(true);
    }
  };

  const handleTabChange = () => {
    let showTabName = componentArr[componentArrIndex + 1];
    hideComponent(showTabName);
    setCurrentTab((prevState) => ({
      ...prevState,
      child1: false,
      child2: false,
    }));
    setUnsavedChanges((prevTab) => ({
      ...prevTab,
      outerClickChild1: false,
      outerClickChild2: false,
    }));
  };

  const handleAboveTabChange = (name) => {
    setTabName((tabName) => (tabName = name));
    // let showTabName = componentArr[componentArrIndex + 1];
    if (currentTab.child3 === false && currentTab.child4 === false) {
      if (currentTab.child1 === false && currentTab.child2 === false) {
        hideComponent(name);
        setCurrentTab((prevState) => ({
          ...prevState,
          child1: false,
          child2: false,
        }));
      } else {
        setIsModalOpenc1(true);
        // setCurrentTab((prevState) => ({
        //   ...prevState,
        //   child1: false,
        //   child2: false,
        // }));
      }
    } else {
      setIsModalOpenValidationFormulation(true);
    }
  };
  const handleNextPageAbove = () => {
    hideComponent(tabName);
    setCurrentTab((prevState) => ({
      ...prevState,
      child1: false,
      child2: false,
    }));
    setUnsavedChanges((prevTab) => ({
      ...prevTab,
      outerClickChild1: false,
      outerClickChild2: false,
    }));
    handleCancelc1();
  };

  const handlePrev = () => {
    setCurrentTab((prevState) => ({
      ...prevState,
      child3: false,
      child4: false,
    }));
    if (currentTab.child1 === false && currentTab.child2 === false) {
      let showTabName = componentArr[componentArrIndex - 1];
      hideComponent(showTabName);
      // setCurrentTab((prevState) => ({
      //   ...prevState,
      //   child1: false,
      //   child2: false,
      // }));
    } else {
      setIsModalOpenc3(true);
      // console.log(currenttab);
    }
  };

  const handlePreviousTabChange = () => {
    let showTabName = componentArr[componentArrIndex - 1];
    hideComponent(showTabName);
    setCurrentTab((prevState) => ({
      ...prevState,
      child1: false,
      child2: false,
    }));
    setUnsavedChanges((prevTab) => ({
      ...prevTab,
      outerClickChild1: false,
      outerClickChild2: false,
    }));
  };
  const handleFacility = () => {
    if (currentTab.child1 === false && currentTab.child2 === false) {
      navigate("/manage-facility/edit-facility/" + btoa(facility_id));
    } else {
      setIsModalOpenc4(true);
    }
  };
  const handlePreviousFacilityChange = () => {
    navigate("/manage-facility/edit-facility/" + btoa(facility_id));
    setCurrentTab((prevState) => ({
      ...prevState,
      child1: false,
      child2: false,
    }));
    setUnsavedChanges((prevTab) => ({
      ...prevTab,
      outerClickChild1: false,
      outerClickChild2: false,
    }));
  };
  return (
    <>
      <Space size={[16, 16]} className="tabbutton">
        <Button
          type="link"
          className={showAddFormulationComponent ? "success" : ""}
          //   onClick={() => hideComponent(componentArr[0])}
          onClick={() => handleAboveTabChange(componentArr[0])}
        >
          <div>
            {formulationCount > 0 ? (
              <CheckOutlined />
            ) : (
              <Loading3QuartersOutlined />
            )}
          </div>
          {t("addFormulation")}
        </Button>
        <Button
          type="link"
          className={showPlantAndLabComponent ? "success" : ""}
          //   onClick={() => hideComponent(componentArr[1])}
          onClick={() => handleAboveTabChange(componentArr[1])}
        >
          <div>
            {plantLabCount > 0 ? (
              <CheckOutlined />
            ) : (
              <Loading3QuartersOutlined />
            )}
          </div>
          {t("plantLab")}
        </Button>
        <Button
          type="link"
          className={showUtilitiesComponent ? "success" : ""}
          //   onClick={() => hideComponent(componentArr[2])}
          onClick={() => handleAboveTabChange(componentArr[2])}
        >
          <div>
            {utilityCount === 1 ? (
              <CheckOutlined />
            ) : (
              <Loading3QuartersOutlined />
            )}
          </div>{" "}
          {t("utilities")}
        </Button>
        <Button
          type="link"
          className={showPhotoGalleryComponent ? "success" : ""}
          //   onClick={() => hideComponent(componentArr[3])}
          onClick={() => handleAboveTabChange(componentArr[3])}
        >
          <div>
            {photoGalleryFormulation_count === 5 ? (
              <CheckOutlined />
            ) : (
              <Loading3QuartersOutlined />
            )}
          </div>
          {t("photoGallery")}
        </Button>
      </Space>
      {showAddFormulationComponent && (
        <Row gutter={[15]}>
          <Col xs={24}>
            <ManageAddFormulation
              facility_id={facility_id}
              formulationMaster={formulationMaster}
              setCurrentTab={setCurrentTab}
            />
          </Col>
        </Row>
      )}
      {showPlantAndLabComponent && (
        <Row gutter={[15]}>
          <Col xs={24}>
            <PlantAndLab
              plantLab_formulation_id={plantLab_formulation_id}
              formulationMaster={formulationMaster}
              setCurrentTab={setCurrentTab}
            />
          </Col>
        </Row>
      )}
      {showUtilitiesComponent && (
        <Row gutter={[15]}>
          <Col xs={24}>
            <Utilities
              utility_formulation_id={utility_formulation_id}
              formulationMaster={formulationMaster}
              subUtility_id={subutility_formulation_id}
              waterTreatment_id={waterTreatmet_formulation_id}
              setCurrentTab={setCurrentTab}
            />
          </Col>
        </Row>
      )}
      {showPhotoGalleryComponent && (
        <Row gutter={[15]}>
          <Col xs={24}>
            <PhotoGallery formulationMaster={formulationMaster} />
          </Col>
        </Row>
      )}
      <br />
      {formulationMaster && (
        <Row>
          <Col xs={24} align="end" className="text-right">
            <Space size={[16, 16]}>
              {componentArrIndex >= 1 && (
                <Button type="primary" onClick={handlePrev}>
                  {t("previous")}
                </Button>
              )}
              {componentArrIndex === 0 && (
                <Button type="primary" onClick={handleFacility}>
                  {t("previous")}
                </Button>
              )}
              {componentArrIndex <= 2 && (
                <Button type="primary" onClick={handleNext}>
                  {t("next")}
                </Button>
              )}
              {componentArrIndex === 3 && (
                <Button
                  type="primary"
                  onClick={() => navigate("/manage-facility")}
                >
                  {t("finish")}
                </Button>
              )}
            </Space>
          </Col>
        </Row>
      )}
      <Modal
        title={t("model_title")}
        open={isModalOpenc}
        footer={null}
        onCancel={handleCancelc}
        width={580}
        className="APImodel"
        wrapClassName="modal-wrapper"
        closable={false}
      >
        <ConfirmAlertModel
          handleCancelc={handleCancelc}
          handleTableChange={handleTabChange}
        />
      </Modal>
      <Modal
        title={t("model_title")}
        open={isModalOpenc1}
        footer={null}
        onCancel={handleCancelc1}
        width={580}
        className="APImodel"
        wrapClassName="modal-wrapper"
        closable={false}
      >
        <>
          <p>{t("model_description_message")}</p>
          <Row gutter={[15]} className="bottomButtons">
            <Col xs={12} align="center">
              <ButtonField
                type="primary"
                htmlType=""
                // loading={btnLoading}
                label={t("button_back")}
                onClick={handleNextPageAbove}
              />
            </Col>
            <Col xs={12} align="center">
              <ButtonField
                type="primary"
                htmlType=""
                // loading={btnLoading}
                label={t("button_save")}
                onClick={handleCancelc1}
              />
            </Col>
          </Row>
        </>
      </Modal>

      <Modal
        title={t("model_title")}
        open={isModalOpenc3}
        footer={null}
        onCancel={handleCancelc3}
        width={580}
        className="APImodel"
        wrapClassName="modal-wrapper"
        closable={false}
      >
        <ConfirmAlertPrevious
          handleCancelc3={handleCancelc3}
          handlePreviousTabChange={handlePreviousTabChange}
        />
      </Modal>

      <Modal
        title={t("model_title")}
        open={isModalOpenc4}
        footer={null}
        onCancel={handleCancelc4}
        width={580}
        className="APImodel"
        wrapClassName="modal-wrapper"
        closable={false}
      >
        <ConfirmPreviousFacility
          handleCancelc4={handleCancelc4}
          handlePreviousFacilityChange={handlePreviousFacilityChange}
        />
      </Modal>
      <Modal
        title={t("model_title_required")}
        open={isModalOpenValidationFormulation}
        footer={null}
        onCancel={handleCancelValidationFormulation}
        width={300}
        className="APImodel"
        wrapClassName="modal-wrapper"
        closable={false}
      >
        <RequiredFieldsModel
          handleCancelc4={handleCancelValidationFormulation}
        />
      </Modal>
      <Modal
        title={t("model_title_required")}
        open={isModalNextValidationFormulation}
        footer={null}
        onCancel={handleCancelNextValidationFormulation}
        width={300}
        className="APImodel"
        wrapClassName="modal-wrapper"
        closable={false}
      >
        <RequiredFieldsNextModel
          handleCancelc4={handleCancelNextValidationFormulation}
        />
      </Modal>
    </>
  );
};

export default Formulation;
